/**
 * @desc 报告种类列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.BaseDictionaryResponseDto>>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/certificationDocument/fileTypeList`, {
      method: "GET",

      ...options,
    }),
  );
}
